import React from 'react'

const InstallAtShopPersistCart = () => <>{/* InstallAtShopPersistCart */}</>

export default InstallAtShopPersistCart
